import * as $ from "jquery";
import * as _ from "lodash";
import { DashboardCategoryCollection } from "../../../collections/DashboardCategories";
import { DashboardChannelCollection } from "../../../collections/DashboardChannels";
import { DashboardNotificationCollection } from "../../../collections/DashboardNotifications";
import { UserGroupCollection } from "../../../collections/UserGroups";
import { BaseModifyModalView, BaseModifyModalViewOptions } from "../_BaseModifyModal";

require('bootstrap-toggle');

interface ModifyDashboardNotificationsModalOptions extends BaseModifyModalViewOptions {
    dashboardCategoryCollection: DashboardCategoryCollection;
    dashboardChannelCollection: DashboardChannelCollection;
    dashboardId?: number;
}

export class ModifyDashboardNotificationsModal extends BaseModifyModalView {
    dashboardNotificationsByUserGroupId = new Map();
    filteredUserGroups = new Map();
    notificationModelsByUserGroupId = new Map();
    options: ModifyDashboardNotificationsModalOptions;
    permissionsCollectionsByUserGroupId = new Map();
    userGroupCollection: UserGroupCollection = null;

    modalBodyTemplate = _.template(require('templates/modals/dashboard/notifications/notificationsModalBody.html'));
    template = _.template(require('templates/modals/dashboard/notifications/notificationsModal.html'));


    ////////////////////////////////////////////////////////////////////////////////
    // Helpers

    private toTime(v) {
        let hour = Math.floor(v / 3600);
        const minutes = Math.floor((v % 3600) / 60);
        let ampm = ' AM';
        if (hour > 11 && hour < 24) ampm = ' PM';

        if (hour < 1) {
            hour += 12;
        } else if (hour > 12) {
            hour -= 12;
        }

        return hour + ':' + (minutes === 0 ? '00' : minutes) + ampm;
    }

    private normalizeSliderValues(sliderVals) {
        if (sliderVals[0] < sliderVals[1]) return sliderVals;
        return [sliderVals[1], sliderVals[0]]
    }

    constructor(options: ModifyDashboardNotificationsModalOptions) {
        super(<any>_.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #notificationsModal': 'handleModalShown',
                'hidden.bs.modal #notificationsModal': 'handleModalHidden',
                'input .dashboard-channel-samples': 'handleDashboardChannelSamplesChange',
                'change .team-checkbox': 'handleTeamCheckbox',
                'change .team-checkbox-main': 'handleTeamCheckboxMain',
                'change .notification-email-enabled, .notification-sms-enabled': 'handleNotificationsEnabled',
                'click .save-notifications-btn': 'handleSaveNotifications',
            }
        }, options));

        // For the base class methods
        this.modalIdSelector = 'notificationsModal';
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Render functions

    show() {
        super.show();
    }

    private renderLoading() {
        this.$el.html(this.template({}));
    }

    render() {
        // Render the base template with loading spinner
        this.renderLoading();

        // Once we load all the collections we need we can render the body template
        $.when(this.ensureCollectionsLoaded())
            .done(() => {
                // Group dashboard channles by category id
                const dashboardChannelsByCategory = new Map();
                for (const channel of this.options.dashboardChannelCollection.models) {
                    // Filter all channels not from dashboard widgets
                    const dashbordWidgetTypes = ['channels', 'chart', 'iaq', 'module_layout', 'multi_gauge', 'sensitivity'];
                    if (!dashbordWidgetTypes.includes(channel.get('dashboard_widget_type'))) continue;

                    const categoryId = channel.get('dashboard_category_id');
                    if (!dashboardChannelsByCategory.get(categoryId)) dashboardChannelsByCategory.set(categoryId, []);
                    // Filter out channels that don't have thresholds
                    if (channel.get('rangesList').length > 1) dashboardChannelsByCategory.get(categoryId).push(channel);
                }

                // Group the Notifications models by user group id
                for (const [userGroupId, collection] of this.dashboardNotificationsByUserGroupId) {
                    let model;
                    if (collection.models.length === 0) {
                        // This is a new notification. Create a new model
                        model = new collection.model({ dashboard_id: this.options.dashboardId });
                        collection.add(model);
                    } else {
                        model = collection.models[0];
                    }
                    // Unset the dashboardId from the collection to prevent using wrong url when saving
                    collection.dashboardId = null;
                    this.notificationModelsByUserGroupId.set(userGroupId, model);
                }

                // Render the body template
                this.$('.modal-body').html(this.modalBodyTemplate({
                    dashboardId: this.options.dashboardId,
                    dashboardCategoryCollection: this.options.dashboardCategoryCollection,
                    dashboardChannelsByCategory: dashboardChannelsByCategory,
                    notificationModelsByUserGroupId: this.notificationModelsByUserGroupId,
                    userGroups: this.filteredUserGroups
                }));

                // Initialize and set up quiet time sliders and buttons
                const view = this;
                this.$el.find('.notifications-quiet-times .bootstrap-toggle, .notifications-quiet-times .bootstrap-toggle-day').change(function () {
                    const group = $(this).parents('.quiet-time-group');
                    view.updateQuietTimeGroup(group);
                });
                (<any>this.$el.find('[data-slider="slider"]')).slider();
                this.$el.find('[data-slider="slider"]').on('slide', function (e: JQuery.UIEventBase) {
                    const group = $(e.currentTarget).parents('.quiet-time-group');
                    view.updateQuietTimeGroup(group);
                });
                this.$el.find('.quiet-time-group').each(function () {
                    view.updateQuietTimeGroup($(this));
                });

                //Initialize bootstrap toggles
                (<any>this.$el.find('.bootstrap-toggle, .bootstrap-toggle-day')).bootstrapToggle();

                // Check/Uncheck team-checkbox-main
                for (const checkbox of $('.team-checkbox')) {
                    if (!$(checkbox).prop('checked')) {
                        $('.team-checkbox-main').prop('checked', false);
                        break;
                    }
                }
            });

        return this;
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Event handlers

    private handleTeamCheckboxMain(e: JQuery.UIEventBase) {
        const isChecked = $(e.currentTarget).prop('checked');
        for (const checkbox of $('.team-checkbox')) {
            const userGroupId = $(checkbox).parents('.notifications-settings-team').attr('data-team-id');
            $(checkbox).prop('checked', isChecked);
            this.$(`.team-${userGroupId}`).toggleClass('hidden', !isChecked);
        }
    }

    private handleTeamCheckbox(e: JQuery.UIEventBase) {
        const userGroupId = $(e.currentTarget).parents('.notifications-settings-team').attr('data-team-id');
        const isChecked = $(e.currentTarget).prop('checked');
        this.$(`.team-${userGroupId}`).toggleClass('hidden', !isChecked);

        // Toggle main checkbox based on all the others
        const $currentTable = $(e.currentTarget).parents('.notifications-team-table');
        let allChecked = true;
        for (const checkbox of $currentTable.find('.team-checkbox')) {
            if (!$(checkbox).prop('checked')) {
                allChecked = false;
                break;
            }
        }
        $('.team-checkbox-main').prop('checked', allChecked);
    }

    private handleDashboardChannelSamplesChange(e: JQuery.UIEventBase) {
        const $target = $(e.currentTarget);
        const $parent = $target.parents('.notifications-channel-team');

        // Automatically enable the channel if the number of samples changes
        (<any>$parent.find('.dashboard-channel-notification-checkbox')).bootstrapToggle('on');

        const samples = Number($target.val());
        if (!samples || _.isNaN(samples)) return;

        const channelId = Number($target.parents('.notifications-channel').attr('data-dashboard-channel-id'));
        const dashboardChannel = this.options.dashboardChannelCollection.findWhere({ dashboard_channel_id: channelId });
        let sampleText = '';
        if (samples == 1) {
            sampleText = '(Immediately)';
        } else {
            sampleText = '(' + ((samples - 1) * Number(dashboardChannel.get('module_polling_frequency'))) + ' seconds)';
        }
        $parent.find('.dashboard-channel-samples-label').text(sampleText);
    }

    private handleNotificationsEnabled(e: JQuery.UIEventBase) {
        const $parent = $(e.currentTarget).parents('.notifications-settings-team');
        const userGroupId = $parent.attr('data-team-id');

        const enableEmailNotifications = $parent.find('.notification-email-enabled').prop('checked');
        const enableSmsNotifications = $parent.find('.notification-sms-enabled').prop('checked');
        // const channelToggles = $(`.team-${userGroupId} .dashboard-channel-notification-checkbox`);
        const notificationsToggleButtons = $(`.team-${userGroupId} .bootstrap-toggle`);
        const channelSamplesFields = $(`.team-${userGroupId} .dashboard-channel-samples`);

        // If both email and sms notification toggles are off,
        // Make the channels and Quiet times not editable
        if (!enableEmailNotifications && !enableSmsNotifications) {
            // Switch button off
            (<any>notificationsToggleButtons).bootstrapToggle('off');
            // Make the button unclickable
            (<any>notificationsToggleButtons).bootstrapToggle('disable');
            // Mouseover shows visibly disabled element
            notificationsToggleButtons.parents('.checkbox').addClass('disabled');
            // Disable Samples Input
            channelSamplesFields.prop('disabled', true);
            // Uncheck to hide team on the channels
            if ($parent.find('.team-checkbox').prop('checked')) {
                $parent.find('.team-checkbox').trigger('click');
            }
        } else {
            // Enable toggles
            (<any>notificationsToggleButtons).bootstrapToggle('enable');
            notificationsToggleButtons.parents('.checkbox').removeClass('disabled');
            // Enable Samples Input
            channelSamplesFields.prop('disabled', false);
            // Make sure we show the team on the channels
            if (!$parent.find('.team-checkbox').prop('checked')) {
                $parent.find('.team-checkbox').trigger('click');
            }
        }
    }

    private updateQuietTimeGroup($group) {
        const label = $group.find('.quiet-time-label');
        const reversedCheckbox = $group.find('.quiet-time-day');
        const reversed = !reversedCheckbox.prop('checked');
        const slider = $group.find('.quiet-time-slider');
        const sliderEnabled = $group.find('.quiet-time-checkbox').prop('checked');
        const sliderUI = $group.find('.slider');

        this.updateSliderText(label, this.normalizeSliderValues(slider.slider('getValue')), sliderEnabled, reversed);
        if (sliderEnabled) {
            slider.slider('enable');
            reversedCheckbox.bootstrapToggle('enable');
        } else {
            slider.slider('disable');
            reversedCheckbox.bootstrapToggle('disable');
        }
        sliderUI.toggleClass('inverted', reversed);
    }

    private updateSliderText(elem, val, on, swapInterval) {
        let text;
        if (!on) {
            text = '';
        } else {
            if (swapInterval) {
                text = "Don't send notifications from <b>" + _.escape(this.toTime(val[1])) + '</b> to <b>' + _.escape(this.toTime(val[0])) + '</b>';
            } else {
                text = "Don't send notifications from <b>" + _.escape(this.toTime(val[0])) + '</b> to <b>' + _.escape(this.toTime(val[1])) + '</b>';
            }
        }
        elem.html(text);
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Save the notifications models:
    // Iterate through userGroups/Teams to get the necessary data for the model
    // -A: Settings
    // -B: Channels
    // -C: Quiet Times
    ////////////////////////////////////////////////////////////////////////////////
    private handleSaveNotifications(e: JQuery.UIEventBase) {
        // Prevent form event and show asving state
        e.preventDefault();
        this.setFormSubmitted();
        const notificationsModelsSave = [];

        for (const userGroupId of this.filteredUserGroups.keys()) {
            // -A: Settings
            const userGroupSettingsRow = this.$(`.notifications-settings-team[data-team-id="${userGroupId}"]`);
            const enableEmailNotifications = userGroupSettingsRow.find('.notification-email-enabled').prop('checked');
            const enableSmsNotifications = userGroupSettingsRow.find('.notification-sms-enabled').prop('checked');
            const enableOkNotifications = userGroupSettingsRow.find('.notification-ok-enabled').prop('checked');

            // -B: Channels (merge: preserve config from other tabs, use form values for current tab)
            const currentTabChannelIds = new Set(
                this.options.dashboardChannelCollection.models.map((c) => c.get('dashboard_channel_id'))
            );
            const savedChannels = (this.notificationModelsByUserGroupId.get(userGroupId).get('dashboard_channels') || []) as Array<{ id: number; num_samples: number }>;
            const channelsFromOtherTabs = savedChannels.filter((c) => !currentTabChannelIds.has(c.id));

            let channelsFromForm: Array<{ id: number; num_samples: number }> = [];
            if (enableEmailNotifications || enableSmsNotifications) {
                const notificationChannelRows = this.$(`.notifications-channel-team[data-team-id="${userGroupId}"]`);
                for (const channelRow of notificationChannelRows) {
                    const $channelRow = $(channelRow);
                    const enabled = $channelRow.find('.dashboard-channel-notification-checkbox').prop('checked');
                    if (!enabled) continue;

                    const channelId = $channelRow.attr('data-dashboard-channel-id');
                    const samples = Number($channelRow.find('.dashboard-channel-samples').val());

                    channelsFromForm.push({
                        id: Number(channelId),
                        num_samples: samples
                    });
                }
            }

            const channels = [...channelsFromOtherTabs, ...channelsFromForm];

            // -C: Quiet Times
            const userGroupQtRow = this.$(`.notifications-qt-team[data-team-id="${userGroupId}"]`);
            let reversed, vals;
            const qt_wd_enabled = userGroupQtRow.find('.notification-weekday-quiet-group .quiet-time-checkbox').prop('checked');
            let qt_wd_start = null, qt_wd_end = null;
            if (qt_wd_enabled) {
                reversed = !userGroupQtRow.find('.notification-weekday-quiet-group .quiet-time-day').prop('checked');
                vals = (<any>userGroupQtRow.find('.notification-weekday-quiet-group .quiet-time-slider')).slider('getValue');
                vals = this.normalizeSliderValues(vals);

                if (reversed) {
                    qt_wd_start = vals[1];
                    qt_wd_end = vals[0];
                } else {
                    qt_wd_start = vals[0];
                    qt_wd_end = vals[1];
                }
            }
            const qt_we_enabled = userGroupQtRow.find('.notification-weekend-quiet-group .quiet-time-checkbox').prop('checked');
            let qt_we_start = null, qt_we_end = null;
            if (qt_we_enabled) {
                reversed = !userGroupQtRow.find('.notification-weekend-quiet-group .quiet-time-day').prop('checked');
                vals = (<any>userGroupQtRow.find('.notification-weekend-quiet-group .quiet-time-slider')).slider('getValue');
                vals = this.normalizeSliderValues(vals);

                if (reversed) {
                    qt_we_start = vals[1];
                    qt_we_end = vals[0];
                } else {
                    qt_we_start = vals[0];
                    qt_we_end = vals[1];
                }
            }

            // Update the moedl with the data and add it to the deferred array
            const model = this.notificationModelsByUserGroupId.get(userGroupId);
            model.set({
                enable_email_notifications: enableEmailNotifications,
                enable_sms_notifications: enableSmsNotifications,
                enable_ok_notifications: enableOkNotifications,
                digest_interval: Number(userGroupSettingsRow.find('.notification-digest-interval').val()),
                dashboard_channels: channels,
                quiet_time_weekday_start_seconds: qt_wd_start,
                quiet_time_weekday_end_seconds: qt_wd_end,
                quiet_time_weekend_start_seconds: qt_we_start,
                quiet_time_weekend_end_seconds: qt_we_end
            });

            notificationsModelsSave.push(model.save());
        }

        $.when.apply($, notificationsModelsSave)
            .done(() => this.hide())
            .fail(() => this.setFormError());
    }

    setFormSubmitted() {
        this.$('.modal-footer button').addClass('hidden');
        this.$('.modal-footer .error-message').addClass('hidden');
        this.$('.modal-footer .modal-form-spinner').removeClass('hidden');
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Fetch the data needed for the template
    // -A: User Group Collection (Teams)
    // -B: Permissions Collections for each User Group
    // -C: Dashboard Notification Collection for each User Group
    ////////////////////////////////////////////////////////////////////////////////
    private ensureCollectionsLoaded() {
        const db = this.options.dashboardCollection.findWhere({ id: this.options.dashboardId });
        const orgId = db.get('organization_id');

        // Create Deferred to resolve once all of the collections are loaded
        const outerDeferred = $.Deferred();
        
        // Use optimized dashboard permission loading if we have a dashboard ID
        if (this.options.dashboardId) {
            $.when(this.loadDashboardPermissions(Number(this.options.dashboardId), Number(orgId)))
                .done(() => {
                    this.loadDashboardNotifications(outerDeferred);
                })
                .fail(() => {
                    // Fallback to original method if new endpoint fails
                    this.loadPermissionsCollectionsFallback(orgId, outerDeferred);
                });
        } else {
            // For new dashboards, use the original method
            this.loadPermissionsCollectionsFallback(orgId, outerDeferred);
        }

        return outerDeferred.promise();
    }

    handleDashboardPermissionsLoaded(userGroupPermissions: any) {
        // Filter User Groups that have necessary permissions to edit this dashboard
        this.userGroupCollection.each((group) => {
            const userGroupId = group.get('id');
            let canView = false;

            if (group.get('is_admin') || this.userGroupCollection.length === 1) {
                this.filteredUserGroups.set(userGroupId, group);
            } else if (userGroupPermissions[userGroupId] && userGroupPermissions[userGroupId].canView) {
                canView = true;
                this.filteredUserGroups.set(userGroupId, group);
            }
        });
    }

    private loadPermissionsCollectionsFallback(orgId: number, outerDeferred: JQueryDeferred<any>) {
        // -A: Fetch  User Group Collection (Teams)
        this.userGroupCollection = new UserGroupCollection([], { organizationId: Number(orgId) });
        $.when(this.userGroupCollection.getCollectionFetchPromise())
            .done(() => {
                // Group Permissions Collections by User Group IDs
                const userGroupPermissionsCollectionsDeferreds = [];
                for (const uGroup of this.userGroupCollection.models) {
                    const userGroupId = uGroup.get('id')
                    const userGroupPermissionsCollection = this.getNewPermissionCollection(userGroupId);

                    this.permissionsCollectionsByUserGroupId.set(
                        userGroupId,
                        userGroupPermissionsCollection
                    );
                    userGroupPermissionsCollectionsDeferreds.push(userGroupPermissionsCollection.fetch())
                }

                // -B: Fetch  Permissions Collections for each User Group
                $.when.apply($, userGroupPermissionsCollectionsDeferreds)
                    .done(() => {
                        // Filter User Groups that have necessary permissions to edit this dashboard
                        for (const uGroup of this.userGroupCollection.models) {
                            const userGroupId = uGroup.get('id');
                            let canView = false;

                            if (uGroup.get('is_admin') || this.userGroupCollection.length === 1) {
                                this.filteredUserGroups.set(userGroupId, uGroup);
                            } else if (this.options.dashboardId) {
                                canView = this.permissionsCollectionsByUserGroupId.get(userGroupId)['canViewDashboard'](this.options.dashboardId);
                                if (canView) {
                                    this.filteredUserGroups.set(userGroupId, uGroup);
                                }
                            }
                        }

                        this.loadDashboardNotifications(outerDeferred);
                    });
            });
        return outerDeferred;
    }

    private loadDashboardNotifications(outerDeferred: JQueryDeferred<any>) {
        // Group Notification Collections by User Group IDs
        const dashboardNotificationsDeferreds = [];
        for (let userGroupId of this.filteredUserGroups.keys()) {
            const notifCollection = new DashboardNotificationCollection([], { userGroupId: userGroupId, dashboardId: this.options.dashboardId });
            this.dashboardNotificationsByUserGroupId.set(
                userGroupId,
                notifCollection
            );
            dashboardNotificationsDeferreds.push(notifCollection.fetch());
        }

        // -C: Fetch Dashboard Notification Collection for each User Group
        $.when.apply($, dashboardNotificationsDeferreds)
            .done(() => {
                // Resolve once all of the collections are fetched
                outerDeferred.resolve();
            });
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/ModifyNotificationsModal.ts